import { webCalendarBadgeClassName } from '@emovia/design-system';

type CalendarBadgeProps = {
  day: string;
  month: string;
};

export function CalendarBadge({ day, month }: CalendarBadgeProps) {
  const calendarBadge = webCalendarBadgeClassName();
  const slots =
    typeof calendarBadge === 'string'
      ? { root: calendarBadge, topBar: '', day: '', month: '' }
      : calendarBadge;

  return (
    <div className={slots.root}>
      <div className={slots.topBar} />
      <span className={slots.day}>{day}</span>
      <span className={slots.month}>{month}</span>
    </div>
  );
}
